import { defineField } from "sanity";
import { SUPPORTED_LANGUAGES } from "../../common/localization";
import { validateMultilingualUrl } from "../../common/customValidations";

export default defineField({
  name: "multilingualUrl",
  title: "Multi-lingual URL",
  type: "object",
  fields: SUPPORTED_LANGUAGES.map((lang) =>
    defineField({
      title: lang.title,
      name: lang.id,
      type: "string",
      validation: (Rule) => Rule.custom(validateMultilingualUrl)
    })
  )
});
